// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1lktN","select":"Header_select__7JAed","clinic":"Header_clinic__3Ep_f"};